<template>
  <div class="display-ticket-item-wrapper">
    <!-- <div class="avatar-wrapper">
      <van-image :src="value.logo" :width="50" :height="50" lazy-load fit="cover" />
    </div> -->
    <div class="description-wrapper">
      <p class="title">{{ value.ticket }}</p>
      <p v-if="value.ticket_two" class="description">{{ value.ticket_two }}</p>
    </div>
    <div class="price-wrapper">￥{{ value.price }}</div>
    <div class="action-wrapper">
      <van-button size="small" color="#B32700" @click="() => handlePurchase(value.id)">
        购买
      </van-button>
    </div>
    <van-dialog
      v-model="show"
      show-cancel-button
      :showCancelButton="false"
      :showConfirmButton="false"
      confirmButtonBackgroundColor="red"
      style="width:70%;"
      className="dialog-main-body"
    >
      <display-card-selector @change="handleRadio" :cards="ticket_type" />
    </van-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DisplayCardSelector from '@/components/DisplayCardSelector';

export default {
  components: {
    DisplayCardSelector,
  },
  props: {
    value: [Object],
  },
  data() {
    return {
      show: false,
      radio: undefined,
      ticket_type: [],
      id: undefined,
    };
  },
  computed: {
    ...mapGetters(['homePage']),
  },
  methods: {
    handlePurchase(id) {
      this.id = id;
      if (this.value.ticket_type.length) {
        this.show = true;
        this.ticket_type = this.value.ticket_type;
      } else {
        this.handleTicketsNotice(this.id);
      }
    },
    handleRadio(radio, type) {
      this.show = false;
      if (type && typeof radio === 'object') {
        this.radio = radio;
        this.handleTicketsNotice(this.id);
      }
    },
    handleTicketsNotice(id) {
      if (this.homePage.ticket_tips.length === 0) {
        this.$emit('purchase', id, this.radio);
      } else {
        const that = this;
        this.$dialog.confirm({
          title: '重要提示',
          message: that.homePage.ticket_tips,
          beforeClose(action, done) {
            if (action === 'confirm') {
              done();
              that.$emit('purchase', id, that.radio);
            } else {
              done();
            }
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .van-dialog__message {
  text-align: justify !important;
}
.display-ticket-item-wrapper {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  &:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
  }
  .avatar-wrapper {
    margin-right: 12px;
    border-radius: 4px;
    height: 50px;
    overflow: hidden;
  }
  .description-wrapper {
    flex: 1;
    text-align: left;
    .description {
      color: #858b9c;
      font-size: 70%;
      margin-top: 8px;
    }
  }
  .price-wrapper {
    color: #faad14;
  }
  .action-wrapper {
    padding-left: 20px;
    button {
      padding: 0 20px;
      border-radius: 5px;
    }
  }
  /deep/ .van-dialog__message {
    text-align: justify;
  }
  .dialog-main-body {
    /deep/ .van-dialog__message {
      text-align: justify;
    }
  }
  /deep/ .van-dialog {
    /deep/ .van-dialog__message {
      text-align: justify;
    }
  }
}
</style>
